import React from 'react'
import { Dropdown, DropdownButton, Nav, NavDropdown } from 'react-bootstrap'
import PropTypes from 'prop-types'
import './_links.scss'

export const MultipleExternalLink = ({ data, scroll }) => {
  switch (data.type) {
    case 'link':
      return (
        <Nav className="">
          <NavDropdown
            id='main-navbar-dropdown-link'
            title={data.name}
            className={`text-uppercase ${scroll < 577 ? 'link-dropdown-white' : 'link-dropdown-dark'}`}
          >
            {data.dropdownlink?.length > 0 &&
              data.dropdownlink.map((item) => {
                return (
                  <a
                    href={item.url}
                    target='_blank'
                    className='dropdown-item'
                    rel='noreferrer'
                    aria-label={item.name}
                    key={`${item.name}-${item.id}`}
                  >
                    <h6 className='mb-0 py-2 text-wrap'>
                      <small>{item.name}</small>
                    </h6>
                  </a>
                )
              })}
          </NavDropdown>
        </Nav>
      )
    case 'button':
      return (
        <DropdownButton
          id='dropdown-button'
          title={data.name}
          className={`btn-dropdown rounded-pill px-2`}
        >
          {data.dropdownlink?.length > 0 &&
            data.dropdownlink.map((item) => (
              <Dropdown.Item
                as='a'
                href={item.url}
                target='_blank'
                className='btn-multiple-text'
                rel='noreferrer'
                aria-label={item.name}
                key={`${item.name}-${item.id}`}
              >
                {item.name}
              </Dropdown.Item>
            ))}
        </DropdownButton>
      )
    case 'buttonWhite':
      return (
        <DropdownButton
          id='dropdown-button'
          title={data.name}
          className={`btn-white-dropdown rounded-pill px-2 ${
            scroll > 577 ? 'btn-white-dropdown-dark' : 'btn-white-dropdown-white'
          }`}
        >
          {data.dropdownlink?.length > 0 &&
            data.dropdownlink.map((item) => (
              <Dropdown.Item
                as='a'
                href={item.url}
                target='_blank'
                className='btn-multiple-text'
                rel='noreferrer'
                aria-label={item.name}
                key={`${item.name}-${item.id}`}
              >
                {item.name}
              </Dropdown.Item>
            ))}
        </DropdownButton>
      )

    default:
      return (
        <Nav className=''>
          <NavDropdown
            id='main-navbar-dropdown-link'
            title={data.name}
            className={`text-uppercase ${scroll < 577 ? 'link-dropdown-white' : 'link-dropdown-dark'}`}
          >
            {data.dropdownlink?.length > 0 &&
              data.dropdownlink.map((item) => {
                return (
                  <a
                    href={item.url}
                    target='_blank'
                    className='dropdown-item'
                    rel='noreferrer'
                    aria-label={item.name}
                    key={`${item.name}-${item.id}`}
                  >
                    <h6 className='text-wrap-lg mb-0 py-2'>
                      <small>{item.name}</small>
                    </h6>
                  </a>
                )
              })
            }
          </NavDropdown>
        </Nav>
      )
  }
}

MultipleExternalLink.propTypes = {
  data: PropTypes.object.isRequired,
  scroll: PropTypes.number
}
